export default require('./InputSlider').default
